import { useEffect, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomText, { textStyles } from "../../components/CustomText";
import TestimonialCard from "../../components/cards/TestimonialCard";
import person1 from "../../assets/person1.png";
import person2 from "../../assets/person2.png";
import person4 from "../../assets/person4.png";
import happyteammainimage from "../../assets/happyteammainimage.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BASE_URL } from "../../components/BASE_URL";
import { useTranslation } from "react-i18next";

// 🔹 Skeleton loader
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const HappyTeamSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
   const { t, i18n } = useTranslation();
  // 🔹 API State
  const [happyData, setHappyData] = useState({ title: "", description: "" });
  const [loading, setLoading] = useState(true);

useEffect(() => {
  async function loadHappyTeams() {
    setLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Home_Happy_Team`
      );
      const json = await res.json();

      const home = (json?.data || []).find(
        (s) => s?.name?.trim().toLowerCase() === "home_happy_team"
      );

      if (home?.items?.length) {
        const selectedItem =
          i18n.language === "es"
            ? home.items.find((item) => item.idx === 1)
            : home.items.find((item) => item.idx === 0);

        setHappyData({
          title: selectedItem?.title || "",
          description: selectedItem?.description || "",
          header: home?.header || "",
        });
      }
    } catch (err) {
      console.error("Error loading Happy Teams section:", err);
    } finally {
      setLoading(false);
    }
  }
  loadHappyTeams();
}, [i18n.language]);


    const testimonials = [
    {
      quote: t("testimonials.0.quote"),
      name: t("testimonials.0.name"),
      role: t("testimonials.0.role"),
      avatar: person1,
      rating: 5,
    },
    {
      quote: t("testimonials.1.quote"),
      name: t("testimonials.1.name"),
      role: t("testimonials.1.role"),
      avatar: person2,
      rating: 4.5,
    },
    {
      quote: t("testimonials.2.quote"),
      name: t("testimonials.2.name"),
      role: t("testimonials.2.role"),
      avatar: person4,
      rating: 3,
    },
    {
      quote: t("testimonials.3.quote"),
      name: t("testimonials.3.name"),
      role: t("testimonials.3.role"),
      avatar: person1,
      rating: 5,
    },
    {
      quote: t("testimonials.4.quote"),
      name: t("testimonials.4.name"),
      role: t("testimonials.4.role"),
      avatar: person2,
      rating: 4.5,
    },
    {
      quote: t("testimonials.5.quote"),
      name: t("testimonials.5.name"),
      role: t("testimonials.5.role"),
      avatar: person4,
      rating: 3,
    },
  ];

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 400,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Box
      sx={{
        position: "relative",
        paddingTop: isMobile ? "50px" : "80px",
        paddingBottom: "100px",
        backgroundImage: `url(${happyteammainimage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* 🔹 Title from API with Skeleton */}
      <CustomText
        style={{
          ...textStyles.h3,
          marginBottom: "1rem",
          marginTop: "1rem",
          color: "#072533",
          maxWidth: "800px",
          margin: "0 auto",
          fontSize: "47px",
        }}
      >
        {loading ? (
          <Skeleton height={40} width={isMobile ? 240 : 400} />
        ) : (
          happyData.title
        )}
      </CustomText>

      {/* 🔹 Description from API with Skeleton */}
      <CustomText
        style={{
          ...textStyles.body3,
          color: "#868282",
          maxWidth: "665px",
          textAlign: "center",
          margin: "30px auto",
          fontWeight: 600,
          paddingLeft: isMobile ? "10px" : "auto",
          paddingRight: isMobile ? "10px" : "auto",
        }}
      >
        {loading ? <Skeleton height={18} count={2} /> : happyData.description}
      </CustomText>

      {/* 🔹 Testimonials Slider */}
      <Box
        sx={{
          maxWidth: "1200px",
          margin: "0 auto",
          mt: 6,
          px: 2,
          overflow: "auto",
          scrollbarWidth: "auto",
          "&::-webkit-scrollbar": { height: 8 },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: " #006EC2",
            borderRadius: "6px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: " #f1f1f1",
          },
        }}
      >
        <Slider {...sliderSettings}>
          {testimonials.map((item, index) => (
            <Box key={index} sx={{ px: 1 }}>
              <TestimonialCard {...item} />
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default HappyTeamSection;




